export const MenuItems = [
  {
    title: "Biography",
    url: "/about",
    cName: "nav-links",
    icon: "fa-solid fa-circle-info"
  },
  {
    title: "Services",
    url: "/service",
    cName: "nav-links",
    icon: "fa-solid fa-address-book"
  },
  {
    title: "Financial Diplomacy (FinDIP)",
    url: "/findip",
    cName: "nav-links nav-links-long",
    icon: "fa-solid fa-landmark"
  },
  {
    title: "Insights",
    url: "/insights",
    cName: "nav-links",
    icon: "fa-solid fa-book-open"
  },
  {
    title: "Contact",
    url: "/contact",
    cName: "nav-links",
    icon: "fa-solid fa-circle-info"
  },
  // {
  //   title: "Contact!",
  //   url: "/contact",
  //   cName: "nav-links-mobile"
  // },
  // {
  //   title: "Contact!",
  //   url: "/contact",
  //   cName: "nav-links-mobile"
  // }
];
